module.exports = __webpack_public_path__ + "img/p14.081511f2.png";